<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="form-title" title="Add TDS">
          <form>
            <div class="vx-row">
              <div class="vx-col md:w-3/4 mx-auto">
                <div class="vx-row mb-6">
                  <div
                    class="vx-col sm:w-1/4 w-full text-left sm:text-right align-self-center"
                  >
                    <h6 class="mb-0">TDS Name*</h6>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <div class>
                      <vs-input
                        v-validate="'required'"
                        name="TDS Name"
                        v-model="form.tds_name"
                        class="w-full"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('TDS Name')"
                        >{{ errors.first("TDS Name") }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div
                    class="vx-col sm:w-1/4 w-full text-left sm:text-right align-self-center"
                  >
                    <h6 class="mb-0">TDS Percentage*</h6>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <div class>
                      <vs-input
                        v-validate="'required|numeric'"
                        name="TDS Percentage"
                        v-model="tds_percentage"
                        class="w-full"
                        type="number"
                        placeholder="0"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('TDS Percentage')"
                        >{{ errors.first("TDS Percentage") }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full text-left sm:text-right">
                    <h6 class="mb-0">Status*</h6>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-switch v-model="switch1" />
                  </div>
                </div>
              </div>
            </div>

            <!-- SUBMIT BUTTON -->
            <div class="vx-row">
              <div class="vx-col mx-auto">
                <vs-button
                  :disabled="submitStatus"
                  type="filled"
                  @click.prevent="submitForm"
                  class="mr-3 mb-3 w-full sm:w-auto"
                  >Submit</vs-button
                >

                <vs-button
                  color="warning"
                  type="border"
                  class=" mb-3 w-full sm:w-auto"
                  @click.prevent="clearForm"
                  >Reset</vs-button
                >
              </div>
            </div>
          </form>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService.js";
import { BASEURL } from "@/config/index.js";
export default {
  data() {
    return {
      submitStatus: true,
      switch1: true,
      form: {
        tds_name: "",
        tds_isActive: 1,
      },
      tds_percentage: null,
      value: [],
      companies: [],
      User: "Select User",
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
    };
  },
  watch: {
    form: {
      handler: function(newVal, oldVal) {
        let len = Object.keys(this.form).length;
        if (
          len ===
          Object.keys(newVal).filter(
            (x, index) =>
              newVal[x] &&
              newVal[x] !== undefined &&
              String(newVal[x]).trim().length > 0
          ).length
        ) {
          this.submitStatus = false;
        } else {
          this.submitStatus = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          this.submitStatus = false;
          let payload = {
            tds_id: this.form.tds_id,
            tds_name: this.form.tds_name,
            tds_percentage: this.tds_percentage,
            tds_isActive: this.switch1 ? "1" : "2",
          };
          MasterService.addTDS(payload)
            .then((response) => {
              this.submitStatus = false;

              const { data } = response;
              this.$vs.loading.close();

              if (data.Status == true || data.Status == "true") {
                this.$vs.notify({
                  title: "Created!",
                  text: data.Message,
                  iconPack: "feather",
                  icon: "check_box",
                  color: "success",
                });
                this.clearForm();
                setTimeout(() => {
                  eventBus.$emit("refreshTabletds", data);
                }, 1);
              } else {
                this.$vs.notify({
                  title: "Error!",
                  text: data.Message,
                  iconPack: "feather",
                  icon: "check_box",
                  color: "warning",
                });
              }
            })
            .catch((error) => {
              this.submitStatus = true;
              console.log("error :", error);
            });
        }
      });
    },
    clearForm: function() {
      Object.keys(this.form).map((x, index) => {
        /_isActive/.test(x) ? (this.form[x] = "1") : (this.form[x] = "");
      });
      this.tds_percentage = null;
      this.submitStatus = false;
      this.$validator.reset();
    },
  },
};
</script>
